import styled from 'styled-components';
import { CardButtonMixin } from '../../mixins/components/CardButtonMixin';
/** A building block of the [`Card`](#/More%20components?id=card) component.  */

var CardButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "CardButton",
  componentId: "c11n-8-64-0__sc-ekym3u-0"
})(["", ""], CardButtonMixin);
/** @component */

export default CardButton;
export var StyledCardButton = CardButton;